import { Button, Icon, Input, Typography } from "@plum-xoxo/admin-dsm";
import React, { useEffect, useState } from "react";
import { TURNSTILE_SITE_KEY } from "../../../constants/AppConstant";
import styled from "styled-components";
import { makeRequestAuth, validateEmail } from "../../../utils/globals";
import profileService from "../../../services/profileService";
import UserExists from "./UserExists";
import config from "config";
import { Turnstile } from "@plum-xoxo/turnstile_captcha";

const StyledInput = styled(Input)`
  input {
    background-color: ${(props) => props.theme.palette.light.c000};
  }
`;

const Email = ({
  setCurrentStep,
  name,
  email,
  setName,
  setEmail,
  setUID,
  showCts,
  setShowCts,
  associationError,
  setAssociationError,
  setRenderDomain,
  countryData,
}) => {
  const [emailError, setEmailError] = useState("");
  const [nameError, setNameError] = useState("");
  const [disabled, setDisabled] = useState(false);
  const [loader, setLoader] = useState(false);
  const [renderTurnstileCaptcha, setRenderTurnstileCaptcha] = useState(false);

  const url = config.storeFrontUrl.replace(/\/$/g, "");

  const validateDetails = () => {
    const userName = name.trim(),
      userEmail = email.trim();

    if (name === "" || userEmail === "" || disabled || loader) return;
    let error = "";

    const nameRaw = userName
      .toLowerCase()
      .replace(/\s(.)/g, ($1) => $1.toUpperCase())
      .replace(/^(.)/g, ($1) => $1.toUpperCase())
      .trimStart();
    setName(nameRaw);

    if (userEmail === "") {
      setEmailError("Please enter the email.");
      return;
    }

    if (userName === "") {
      setNameError("Please enter name.");
      return;
    } else {
      setNameError("");
    }

    if (validateEmail(userEmail)) {
      const lastAtPos = userEmail.lastIndexOf("@");
      const lastDotPos = userEmail.lastIndexOf(".");
      const re = /.+@(gmail|yahoo)\.com$/;
      if (
        lastAtPos < lastDotPos &&
        lastAtPos > 0 &&
        userEmail.indexOf("@@") == -1 &&
        lastDotPos > 2 &&
        userEmail.length - lastDotPos > 2
      ) {
        if (userEmail.match(re)) {
          error = "Enter a valid work email.";
        } else {
          handleEmailAssociation();
        }
      } else {
        error = "Enter a valid work email.";
      }
    } else {
      setDisabled(true);
      error = "Enter a valid work email.";
    }

    setEmailError(error);
  };

  const validateDomain = (token = "", checkDomain = true) => {
    let domainPromise = new Promise((resolve, reject) => {
      const query = "diy.mutation.validate_email_plum_diy_v2";
      // const utkData = getCookieToken("hubspotutk");
      const requestData = {
        query,
        tag: "diy",
        variables: {
          email: email.trim(),
          token: token,
          firstname: name.trim(),
          checkDomain,
          country: countryData?.name,
        },
      };

      makeRequestAuth(
        requestData,
        (response) => {
          if (response) {
            resolve(response);
          } else {
            reject(0);
          }
        },
        {},
        "/api/public/graph"
      );
    });

    domainPromise
      .then((response) => {
        const data = response?.data?.validateEmailPlumDIYV2;
        setLoader(false);
        if (data?.success == 1 && !data.domainExists && data.diy_uuid) {
          setCurrentStep(1);
          setUID(data.diy_uuid);
        } else if (data?.domainExists) {
          setAssociationError("domainExists");
        } else {
          setEmailError("Invalid Email, Please try with some other email id.");
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const handleEmailAssociation = () => {
    setLoader(true);

    const payload = {
      user_input: email.trim(),
      source: "admin",
    };

    profileService
      .getUserAssoc(payload)
      .then((response) => {
        if (response.data.getUserAssocAcc.success === 1) {
          if (response.data.getUserAssocAcc.showCts) {
            setRenderTurnstileCaptcha(true);
            setShowCts(true);
          } else {
            return validateDomain("", true);
          }
        } else if (
          [
            "xoxoCodeAndPointUser",
            "xoxocodeUser",
            "xoxopointUser",
            "userAlreadyExists",
          ].includes(response?.data?.getUserAssocAcc?.errmsg)
        ) {
          setLoader(false);
          if (response?.data?.getUserAssocAcc?.userExists)
            setAssociationError("userAlreadyExists");
          else setAssociationError(response?.data?.getUserAssocAcc?.errmsg);
        } else if (response?.data?.getUserAssocAcc?.errmsg) {
          setLoader(false);
          setEmailError(response?.data?.getUserAssocAcc?.errmsg);
        }
      })
      .catch((e) => {
        console.log("Something went wrong");
      });
  };

  const button1Action = () => {
    if (
      associationError === "xoxopointUser" ||
      associationError === "userAlreadyExists"
    ) {
      const encodeEmail = encodeURIComponent(email.trim());
      window.location.href = url + `/marketplace/login?email=${encodeEmail}`;
    } else if (associationError === "domainExists") {
      setRenderDomain(true);
    } else {
      window.location.href = url + "/marketplace/vouchers";
    }
  };

  const button2Action = (token = "") => {
    setRenderDomain(false);
    setAssociationError("");
    if (associationError === "userAlreadyExists") {
      setEmail("");
      setName("");
    } else {
      validateDomain(token, false);
      setCurrentStep(1);
    }
  };

  useEffect(() => {
    setEmailError("");
    if (disabled && name && email) setDisabled(false);
  }, [email]);

  return (
    <>
      {associationError ? (
        <UserExists
          associationError={associationError}
          email={email}
          button1Action={button1Action}
          button2Action={button2Action}
          showCts={showCts}
        />
      ) : (
        <div className="d-flex flex-column gap-16 w-100">
          <div>
            <Typography.BodySmall className="mb-4">
              Step 1 of 3
            </Typography.BodySmall>
            <Typography.H1 className="mb-4">Create your account</Typography.H1>
            <Typography.BodySmall>
              Join thousands of organizations that trust Xoxoday for all their
              rewarding needs.
            </Typography.BodySmall>
          </div>
          <StyledInput
            className="mb-4"
            type="text"
            placeholder="Enter your full name"
            value={name}
            error={nameError}
            onChange={(e) => setName(e.target.value)}
            helperText={nameError || ""}
          />
          <StyledInput
            className="mb-4"
            type="email"
            error={emailError}
            placeholder="Enter your work email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") validateDetails();
            }}
            helperText={emailError || ""}
          />
          {renderTurnstileCaptcha ? (
            <Turnstile
              siteKey={TURNSTILE_SITE_KEY}
              options={{ theme: "light" }}
              onSuccess={(token) => validateDomain(token, true)}
            />
          ) : (
            <Button
              loading={loader}
              disabled={name === "" || email === "" || disabled || loader}
              endIcon={<Icon iconName="RightArrow" color="white" />}
              size={"large"}
              className="mt-12"
              onClick={validateDetails}
              isLoading={loader}
            >
              Continue
            </Button>
          )}

          <div className="d-flex align-items-center">
            <Typography.LabelText
              color="dark"
              shade="c200"
              className="mt-12 pr-2"
            >
              Already have an account?{" "}
            </Typography.LabelText>
            <Button
              variant="plain"
              className="p-0 ps-1 mt-12"
              onClick={() =>
                (window.location.href = url + `/marketplace/login`)
              }
            >
              Log in
            </Button>
          </div>
        </div>
      )}
    </>
  );
};

export default Email;
